import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ProductAdmin } from 'api/AdminApi';
import Config from 'configuration';

const initialProductAdminList = () => {
    if (sessionStorage.getItem(Config.storageKey.productAdmin)) {
        return {
            ...JSON.parse(
                sessionStorage.getItem(Config.storageKey.productAdmin),
            ),
        };
    }
    return {
        productAdminList: [],
    };
};

export const getListProductAdmin = createAsyncThunk(
    'productAdmin/listProductAdmin',
    async (params) => {
        const res = await ProductAdmin.getListProduct(params);
        return res;
    },
);

export const getProductAdminById = createAsyncThunk(
    'productAdmin/ProductAdminById',
    async (id) => {
        const res = await ProductAdmin.getProductById(id);
        return res;
    },
);

export const insertProductAdmin = createAsyncThunk(
    'productAdmin/insertProductAdmin',
    async (params) => {
        const res = await ProductAdmin.insertProduct(params);
        return res;
    },
);

export const updateProductAdmin = createAsyncThunk(
    'productAdmin/updateProductAdmin',
    async (params) => {
        const res = await ProductAdmin.updateProduct(params);
        return res;
    },
);

export const deleteProductAdmin = createAsyncThunk(
    'productAdmin/deleteProductAdmin',
    async (params) => {
        const res = await ProductAdmin.deleteProduct(params);
        return res;
    },
);


export const getUnit = createAsyncThunk(
    'productAdmin/Unit',
    async () => {
        const res = await ProductAdmin.getUnit();
        return res;
    },
);

export const getQrCode = createAsyncThunk(
    'productAdmin/QrCode',
    async (code) => {
        const res = await ProductAdmin.getQr(code);
        return res;
    },
);

const productAdmin = createSlice({
    name: 'productAdmin',
    initialState: initialProductAdminList(),
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getListProductAdmin.fulfilled, (state, action) => {
                state.productAdminList = action.payload.responseData;
            })
            .addCase(getListProductAdmin.rejected, (state, action) => { });
    },
});

const { reducer } = productAdmin;
export default reducer;
